import React from "react";

import DoneIcon from "@mui/icons-material/Done";
import { Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";
import { IProfileAssetClass } from "store/types/user/social";

const tableCellCommonStyle = {
  padding: 0,
  color: "#bac7ce",
  fontSize: "13px"
};

interface ITableAssetProps {
  data: IProfileAssetClass[];
  groupTitle: string;
  index: number;
}

export const AssetTable: React.FC<ITableAssetProps> = ({ data, groupTitle, index }) => {
  return (
    <Table sx={{ width: "100%", mb: !index ? "35px" : "0" }} aria-label="simple table">
      {!index && (
        <TableHead>
          <Typography color="#0a3142" fontSize="16px" fontWeight="500" mb="20px">
            Asset Classes
          </Typography>
        </TableHead>
      )}
      <TableHead>
        <TableRow>
          <TableCell sx={{ ...tableCellCommonStyle, width: "70%" }} align="left">
            {groupTitle}
          </TableCell>
          <TableCell sx={{ ...tableCellCommonStyle, width: "15%" }} align="center">
            Currently Investing
          </TableCell>
          <TableCell sx={{ ...tableCellCommonStyle, width: "15%" }} align="center">
            Would like to learn
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {data.length &&
          data.map((item: IProfileAssetClass, index: number) => {
            return (
              <TableRow key={index}>
                <TableCell
                  sx={{
                    ...tableCellCommonStyle,
                    color: "#0a3142",
                    padding: "11px 0 11px 0 !important",
                    textAlign: "left !important"
                  }}
                  align="center"
                >
                  {item.title}
                </TableCell>
                <TableCell sx={{ ...tableCellCommonStyle }} align="center">
                  {item.investment && <DoneIcon sx={{ color: "#48a8d1" }} />}
                </TableCell>
                <TableCell sx={{ ...tableCellCommonStyle }} align="center">
                  {item.learn_more && <DoneIcon sx={{ color: "#48a8d1" }} />}
                </TableCell>
              </TableRow>
            );
          })}
      </TableBody>
    </Table>
  );
};
